import { hexToRGBA } from 'shared/utils/color-convert/hex-to-rgba'
import { additionalColors } from './constants'
import { MappedThemeInterface, ThemeInterface, ThemeValueType } from './types'

type ThemeColorValues = Record<string, ThemeValueType>

const mapTheme = (variables: ThemeColorValues): MappedThemeInterface => {
  const mapped: MappedThemeInterface = {}
  for (const [key, value] of Object.entries(variables)) {
    mapped[`--THEME-${key}`] = value
  }
  return mapped
}

const addAdditionalColors = (baseColors: ThemeInterface): ThemeColorValues => {
  const extras: ThemeColorValues = {}
  for (const [name, params] of Object.entries(additionalColors)) {
    const baseColor = baseColors[params.baseColor]
    if (!baseColor || params.opacity === undefined || name in baseColors) continue
    extras[name] = hexToRGBA(baseColor, params.opacity)
  }
  return Object.assign({}, baseColors, extras)
}

export const applyTheme = (theme: ThemeInterface): void => {
  const themeObject = mapTheme(addAdditionalColors(theme))
  if (themeObject) {
    const root = document.documentElement

    Object.keys(themeObject).forEach(property => {
      root.style.setProperty(property, themeObject[property])
    })
  }
}
